/**
 * Created by vlad on ???
 */

const Decors = function (window, styles) {
    styles = styles || {};
    this.styles = styles;
    this.decors = {};
    this.parent = window;

    if (!cleverapps.styles.Decorators) {
        return;
    }

    const ids = Object.keys(styles).filter((id) => {
        if (styles[id] !== true) {
            return false;
        }

        const decorator = cleverapps.styles.Decorators[id];

        if (!decorator) {
            return false;
        }

        if (decorator.lovesBackground && !window.withBg) {
            return false;
        }

        if (decorator.lovesBackgroundAndForeground && !window.withBg && !window.foreground) {
            return false;
        }

        if (decorator.fearHigh && window.window) {
            const height = window.window.height * window.window.scale / cleverapps.resolution.getSceneSize().height;
            if (height > 0.8) {
                return false;
            }
        }

        if (decorator.lovesTitle && (!window.windowTitle || decorator.lovesTitle !== true && window.windowTitle.type !== cleverapps.styles.WindowTitle.Types[decorator.lovesTitle])) {
            return false;
        }

        return true;
    });

    this.init(ids);
};

Decors.prototype.add = function (id) {
    const item = cleverapps.styles.Decorators[id];
    if (item) {
        const parent = this.getParent(item);
        let decor;
        switch (item.type) {
            case Decors.TYPE_IMAGE:
                decor = this.addImage(item);
                break;
            case Decors.TYPE_ANIMATION:
                decor = this.addAnimation(item);
                break;
            case Decors.TYPE_SCALE9:
                decor = this.addScale9(item, parent);
                break;
            case Decors.TYPE_REPEATABLE:
                decor = this.addPattern(item);
                break;
        }

        if (decor) {
            const pos = this.getPos(item);
            parent.addChild(decor);
            decor.setAlignment(pos);
            this.decors[id] = decor;
            return decor;
        }
    }
};

Decors.prototype.init = function (ids) {
    ids.forEach(this.add, this);
};

Decors.prototype.initTitleDecorators = function () {
    const ids = Object.keys(this.styles).filter((id) => this.styles[id] === true && cleverapps.styles.Decorators[id] && cleverapps.styles.Decorators[id].lovesTitle);

    this.init(ids);
};

Decors.prototype.getDecorById = function (id) {
    if (this.decors[id]) {
        return this.decors[id];
    }
};

Decors.prototype.setVisible = function (id, visible) {
    const decor = this.getDecorById(id);
    if (!decor) {
        return false;
    }
    if (!visible) {
        decor.stopAllActions();
    }
    decor.setVisible(visible);
    return true;
};

Decors.prototype.getParent = function (item) {
    if (item.lovesTitle) {
        return this.parent.windowTitle;
    }

    if (item.lovesBackground) {
        return this.parent.bg;
    }

    if (item.lovesBackgroundAndForeground && (this.parent.foreground || this.parent.bg)) {
        return this.parent.foreground || this.parent.bg;
    }

    if (item.lovesWindow) {
        return this.parent;
    }

    if (item.lovesButton && this.parent.button) {
        return this.parent.button;
    }

    return this.parent.window;
};

Decors.prototype.addScale9 = function (item, parent) {
    const image = cleverapps.UI.createScale9Sprite(bundles.main.frames[item.image] || item.image);
    image.setContentSize2(item.width === "parent" ? parent.width : image.width, item.height === "parent" ? parent.height : image.height);
    image.setScale(Array.isArray(item.scale) ? item.scale[cleverapps.resolution.mode] : item.scale);
    image.baseScale = image.scale;
    image.setLocalZOrder(item.zOrder);
    if (item.rotation !== undefined) {
        image.setRotation(item.rotation);
    }
    return image;
};

Decors.prototype.addImage = function (item) {
    const image = new cc.Sprite(bundles.main.frames[item.image] || item.image);
    let scale = item.scale;
    if (Array.isArray(scale)) {
        scale = scale[cleverapps.resolution.mode];
    }
    if (typeof scale === "number") {
        image.scale = scale;
    } else {
        image.scaleX = scale.x;
        image.scaleY = scale.y;
    }
    
    image.baseScale = Math.abs(image.scaleX);
    image.baseScaleX = image.scaleX;
    image.baseScaleY = image.scaleY;
    image.setLocalZOrder(item.zOrder);
    if (item.rotation !== undefined) {
        image.setRotation(item.rotation);
    }
    return image;
};

Decors.prototype.addAnimation = function (item) {
    const json = bundles.main.jsons[item.json] || item.json;
    const animation = new cleverapps.Spine(json);
    if (item.scale) {
        if (item.scale.x) {
            animation.setScale(item.scale.x, item.scale.y);
        } else {
            animation.setScale(item.scale);
        }
    }
    const looped = item.looped !== undefined ? item.looped : true;
    animation.setLocalZOrder(item.zOrder);
    animation.setVisible(true);

    if (item.delay !== undefined) {
        animation.runAction(new cc.Sequence(
            new cc.DelayTime(item.delay),
            new cc.CallFunc(() => {
                animation.setAnimation(0, item.animation, looped);
            })
        ));
    } else if (item.idle) {
        animation.setAnimationAndIdleAfter(item.animation, item.idle);
    } else {
        animation.setAnimation(0, item.animation, looped);
    }

    return animation;
};

Decors.prototype.addPattern = function (item) {
    const frame = bundles.main.frames[item.image] || item.image;
    const parent = this.getParent(item);
    const step = item.step;

    const count = (item.direction === cleverapps.UI.HORIZONTAL
        ? Math.ceil(parent.width / 2 / item.step) - 1
        : Math.ceil(parent.height / 2 / item.step) - 1) * 2;

    const container = new cc.Node();
    container.setAnchorPoint(0.5, 0.5);
    container.setLocalZOrder(item.zOrder || 0);

    for (let index = 0; index < count; ++index) {
        const image = new cc.Sprite(frame);
        container.addChild(image);

        if (item.direction === cleverapps.UI.HORIZONTAL) {
            image.setPosition(parent.width / 2 + (index - count / 2 + 0.5) * step, 0);
        } else {
            image.setPosition(0, parent.height / 2 + (index - count / 2 + 0.5) * step);
        }
    }

    return container;
};

Decors.prototype.getPos = function (item) {
    let pos;
    if (item.position && Array.isArray(item.position)) {
        pos = item.position[cleverapps.resolution.mode];
    } else {
        pos = cc.p(item.x, item.y);
    }

    if (item.compensateSafePadding) {
        const safePadding = cleverapps.resolution.getSafePadding();
        pos = {
            x: pos.x,
            y: { ...pos.y, dy: (pos.y.dy || 0) - safePadding.bottom }
        };
    }

    return pos;
};

Decors.prototype.updateAll = function () {
    for (const id in this.decors) {
        const decor = this.decors[id];
        const decorStyle = cleverapps.styles.Decorators[id];

        if ([Decors.TYPE_SCALE9, Decors.TYPE_REPEATABLE].includes(decorStyle.type)) {
            decor.removeFromParent();
            this.add(id);
        } else {
            const pos = this.getPos(decorStyle);
            decor.setAlignment(pos.x, pos.y);
        }
    }
};

Decors.prototype.hideAll = function () {
    for (const id in this.decors) {
        const item = cleverapps.styles.Decorators[id];
        if (item && item.type === Decors.TYPE_ANIMATION) {
            const decor = this.decors[id];
            const fadeoutAnimation = `${item.animation}_fadeout`;
            if (decor && decor.hasAnimation && decor.hasAnimation(fadeoutAnimation)) {
                decor.setAnimation(0, fadeoutAnimation, false);
                decor.setCompleteListenerRemove();
            }
        }
    }
};

Decors.TYPE_IMAGE = 0;
Decors.TYPE_ANIMATION = 1;
Decors.TYPE_SCALE9 = 2;
Decors.TYPE_REPEATABLE = 3;

cleverapps.styles.Decorators = {

};
